import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadpartytokenComponent } from '../uploadpartytoken/uploadpartytoken.component';
import { DeleteGameAndCharacterModalComponent } from '../../game-master-detail/delete-character-modal/delete-character-modal.component';
import { DataService } from 'src/app/services/data.service';
import { ToastService } from 'src/app/services/toast.service';
import { ip } from 'src/app/constant/constant';

@Component({
    selector: 'app-game-details-modal',
    templateUrl: './game-details-modal.component.html',
    styleUrls: ['./game-details-modal.component.scss'],
    standalone: false
})
export class GameDetailsModalComponent implements OnInit {
  acceptedChar_details: any;
  @Input() activeCharacters: any = [];
  imageurl = ip;
  partyToken: string = '';
  listofRemoveCharacters: any[] = [];
  partyTokenUrl: string;

  constructor(
    private router: Router,
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private dataService: DataService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
  ) { }
  @Input() map_id: string;
  @Input() game_id: any;
  @Input() activePlayers: any = [];
  @Input() game_details: any = [];

  /** Seats taken by a character (the rest are open). */
  get seatedCount(): number {
    return (this.acceptedChar_details || []).filter((c: any) => c.character_id).length;
  }

  /** Two letters for a seat circle: nickname + last name. */
  initials(char: any): string {
    const first = (char?.nickname || char?.first_name || '').trim();
    const last = (char?.last_name || '').trim();
    return ((first[0] || '') + (last[0] || first[1] || '')).toUpperCase() || '?';
  }

  ngOnInit(): void {
    this.urlToBase64(this.imageurl + this.game_details.partytoken).then(
      (res) => {
        this.partyToken = res;
      },
    );
    if (!this.activeCharacters.length) {
      this.acceptedChar_details = [
        ...(this.game_details.active_characters || []),
      ];
      while (this.acceptedChar_details.length < 8) {
        this.acceptedChar_details.push({ user_name: '#OPEN' });
      }
    } else {
      this.acceptedChar_details = [...this.activeCharacters];
    }
  }

  downloadGmGuide(): void {
    const mapId = this.map_id || this.game_details?.map_id;
    if (!mapId) {
      this.toastService.showNote("We couldn't find this game's map.", 'warning');
      return;
    }
    this.dataService.downloadGmGuide(mapId).subscribe({
      next: (res: any) => {
        const blob = res.body;
        if (blob) {
          let filename = `GM_Guide_${mapId}.pdf`;
          const contentDisposition = res.headers.get('content-disposition');
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
              filename = match[1];
            }
          }
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(blobUrl);
        }
          this.cdr.detectChanges();},
      error: (err: any) => {
        console.warn('GM guide download error:', err);
        this.toastService.showNote("The GM Guide isn't ready yet for this map.", 'warning');
          this.cdr.detectChanges();}
    });
  }

  downloadPlayerGuide(): void {
    const mapId = this.map_id || this.game_details?.map_id;
    if (!mapId) {
      this.toastService.showNote("We couldn't find this game's map.", 'warning');
      return;
    }
    this.dataService.downloadFieldGuide(mapId).subscribe({
      next: (res: any) => {
        const blob = res.body;
        if (blob) {
          let filename = `Player_Guide_${mapId}.pdf`;
          const contentDisposition = res.headers.get('content-disposition');
          if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
              filename = match[1];
            }
          }
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(blobUrl);
        }
          this.cdr.detectChanges();},
      error: (err: any) => {
        console.warn('Field guide download error:', err);
        this.toastService.showNote("The Player Guide isn't ready yet for this map.", 'warning');
          this.cdr.detectChanges();}
    });
  }

  urlToBase64(url: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result as string);};
        reader.onerror = function (error) {
          reject(error);
        };
        reader.readAsDataURL(xhr.response);};
      xhr.onerror = function (error) {
        reject(error);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }

  handlePlayClick() {
    if (this.game_details.spawn_city?.length > 0) {
      ;
      // Redirect to city-map-view
      this.router.navigate(
        [
          '/city-map-view/' +
          this.game_details.spawn_city +
          '/' +
          this.map_id +
          '/' +
          (this.game_id ? this.game_id : 'null') +
          '/' +
          'null',
        ],
        {
          queryParams: {
            token: this.partyTokenUrl,
            backRoute: 'mapview',
            isLoadToken: true,
            isPlaceToken: this.game_details.spawn_location,
          },
        },
      );
    } else {
      // Use the existing map-view-player or mapview route
      this.router.navigate(['/mapview/' + this.map_id + '/' + this.game_id]);
    }
    this.activeModal.close();
  }

  handleDetailClick() {
    this.router.navigate(['/game-master-detail/' + this.game_id + '/']);
    this.activeModal.close();
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  uploadPartyToken(data: any) {
    const modalRef = this.modalService.open(UploadpartytokenComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.masterUpdate = data.id;
    modalRef.result.then((res) => {
      if (res) {
        this.partyToken = res;
      }
    
          this.cdr.detectChanges();});
  }

  onPlayerRemoveTick(character) {
    const index = this.listofRemoveCharacters.findIndex(
      (id) => id === character.character_id,
    );

    if (index !== -1) {
      // Remove the character if it exists
      this.listofRemoveCharacters.splice(index, 1);
    } else {
      // Add the character if it doesn't exist
      this.listofRemoveCharacters.push(character.character_id);
    }
  }

  openCharacterDeleteConfirmModal(isAllDisband: boolean) {
    const deletemodalRef = this.modalService.open(
      DeleteGameAndCharacterModalComponent,
      {
        size: 'md',
        backdrop: 'static',
        centered: true,
      },
    );
    deletemodalRef.componentInstance.game_id = this.game_id;
    deletemodalRef.componentInstance.character_ids =
      this.listofRemoveCharacters;
    deletemodalRef.componentInstance.isAllDisband = isAllDisband;

    deletemodalRef.result.then((res) => {
      if (res) {
        this.gamedetailbygameid(this.game_id);
      }
    
          this.cdr.detectChanges();});
  }

  gamedetailbygameid(game_id: number) {
    this.dataService.gamedetailby_game_id(game_id).subscribe((res: any) => {
      this.game_details = res.game_details;
      this.acceptedChar_details = res.active_characters || [];
      this.listofRemoveCharacters = [];
      // Push placeholder objects if the array length is less than 8
      while (this.acceptedChar_details.length < 8) {
        this.acceptedChar_details.push({ user_name: '#OPEN' });
      }
      this.cdr.detectChanges();
      // this.rejectedCharDetails = res.rejected_requests || [];
      // this.pendingInvitation = res.pending_requests || [];
    });
  }
}
